import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { uniq } from 'ramda'
import { Link } from 'react-router'
import IntegrationBreadcrumb from 'components/Integration/components/IntegrationBreadcrumb'
import withNotifications from 'components/shared/notifications'
import ACCESS from 'utils/Access'
import moment from 'moment'
import { api } from 'app/modules/sfdc/api'
import { Button } from '@driftt/tide-core-legacy'

import './style.styl'

class SalesforceAccountSyncErrors extends Component{

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  state = {
    syncHistory: {}
  }

  componentDidMount() {
    api.fetchSFDCAccountListSyncHistory()
      .then(this.receiveHistory)
  }

  resync = () => {
    api.resyncAccountList()
      .then(() => this.props.notifications.success(' We are re-syncing your accounts :)'))
  }

  receiveHistory = resp => {
    this.setState({
      syncHistory: resp
    })
  }

  renderErrorList = (errors) => {
    return errors.map(name => {
      return (
        <div 
          className="account-sync-error-list-item" 
          key={name}
        >
          {name}
        </div>
      )
    })
  }

  render() {
    const { syncHistory } = this.state
    if (!syncHistory.updateDateTime) return <div />

    const { results } = syncHistory

    const errors = uniq([...results.FAILED_NODOMAIN, ...results.FAILED_NOOWNER].map(error => error.name))
    const formattedDate = `${moment(syncHistory.updateDateTime).format('DD/MM/YYYY')} at ${moment(syncHistory.updateDateTime).format('HH:MM')}`

    return (
      <div className="common-integration-page-layout account-sync-error-page">
        <div className="account-sync-error-breadcrumbs">          
          <IntegrationBreadcrumb
            backLinkText="Salesforce Integration"
            backLinkUrl="/settings/setup/salesforce"
          />
          <IntegrationBreadcrumb
            backLinkText="Synced Salesforce Data"
            backLinkUrl="/settings/salesforce/config"
          />
        </div>
        <header>
          <h2 className="integration-header">Account List Sync Errors for {formattedDate}</h2>
            {(errors && errors.length > 0) && <p>We couldn&#39;t sync {errors.length} accounts because they were missing required information.</p>}

          <h3 className="integration-header">Not Synced Accounts</h3>
          <p className="account-sync-error-page-warning-text">
            Please double check the accounts below to make sure that they have a website field, and also that the Account Owner in Salesforce is mapped to a Drift teammate
            <Link to="/settings/salesforce/mapping/users"> here.</Link>
          </p>

          <div className="account-sync-error-list-container">
            {this.renderErrorList(errors)}
          </div>  

          <Button 
            type="subtle" 
            size="medium" 
            onClick={this.resync} 
          >
            Resync Accounts
          </Button>
        </header>

      </div>
    )
  }
}

export default withNotifications(SalesforceAccountSyncErrors)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/SalesforceAccountSyncErrors/index.js